import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "../../customers/forms/ChangeShippingAddressForm";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {cancelChangeShippingAddress, requestAddShippingAddress} from "../../actions/CheckoutApiActions";
import {fromJS} from "immutable";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

class ChangeShippingAddressFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { 
      selectedId: "current",
      errors: [] 
    }
  }

  handleSubmit(values) {
    if (this.state.selectedId === "current") {
      this.props.cancelChangeShippingAddress();
    } else {
      return this.props.assignExistingShippingAddress({orderId: this.props.orderId, accountId: this.props.accountId, addressId: this.state.selectedId})
        .then((response) => {
          if (response.data.assignExistingShippingAddress.errors.length <= 0) {
            this.props.cancelChangeShippingAddress();
          } else {
            let errors = createValidationErrors(response.data.assignExistingShippingAddress.errors);
            this.setState({errors: errors});            
          }
        })
        .catch((err) => {
          this.setState({errors: createErrors(err)});
        });      
    }
  }

  handleCancel() {
    this.props.cancelChangeShippingAddress();
  }

  handleNewAddress() {
    this.props.requestAddShippingAddress(this.props.accountId, this.props.orderId);
  }

  handleSelectAddressId(id) {
    this.setState({
      selectedId: id
    })
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    return (
      <Form
        errors={this.state.errors}
        selectedAddress={fromJS(data.checkoutInfo.shippingAddress)}
        usedShippingAddresses={fromJS(data.shippingAddresses)}
        selectedId={this.state.selectedId}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        onNewAddress={this.handleNewAddress.bind(this)}
        onSelect={this.handleSelectAddressId.bind(this)}
        />
    )
  }
}

const CUSTOMER_ADDRESSES = gql`
  query customerAddresses($accountId:ID!, $orderId:ID!) {
    checkoutInfo(orderId: $orderId) {
      shippingAddressStatus
      shippingAddress {
        type
        name
        attName
        phoneNr
        email
        addressAddressLine1
        addressAddressLine2
        addressCity
        addressPostcode
        addressStateProvince
        addressCountryName
        addressCountryCode
      }
    }
    shippingAddresses(accountId: $accountId) {
      addressId
      address {
        type
        name
        attName
        phoneNr
        email
        addressAddressLine1
        addressAddressLine2
        addressCity
        addressPostcode
        addressStateProvince
        addressCountryName
        addressCountryCode
      }
    }
  }
`;

const ASSIGN_EXISTING_ADDRESS = gql`
  mutation assignExistingShippingAddress($data: OrderExistingShippingAddressInput!) {
    assignExistingShippingAddress(input: $data) {
      errors { key message }
    }
  }
`

const withQueries = compose(
  graphql(CUSTOMER_ADDRESSES, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        accountId: props.accountId,
        orderId: props.orderId
      }
    })
  }),
  graphql(ASSIGN_EXISTING_ADDRESS, {
    props: ({ mutate }) => ({
      assignExistingShippingAddress: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

export default connect(null, {cancelChangeShippingAddress, requestAddShippingAddress})(withQueries(ChangeShippingAddressFormContainer));